import { BlobPrinterService } from "src/app/services/print/blob/blob-printer.service";

export class DesktopBlobPrinterService extends BlobPrinterService {
  private iframe: HTMLIFrameElement | null = null;

  print({ blob, name }: { blob: Blob; name: string }): Promise<void> {
    return new Promise<void>((res, rej) => {
      this.#chePrintIframe();

      this.iframe!.src = URL.createObjectURL(blob);

      this.iframe!.onload = () => {
        setTimeout(() => {
          this.iframe!.contentWindow!.print();
          res();
        });
      };

      this.iframe!.onerror = this.iframe!.onabort = (ex: any) => {
        console.error(ex);
        rej(ex);
      };
    });
  }

  #chePrintIframe(): void {
    if (!this.iframe) {
      this.iframe = document.querySelector("#snt-iframe-print-pdf");
    }
  }
}
